import {useState, useEffect} from "react";
import Constants from "../Constants";
import {Link} from "react-router-dom";
import {useNavigate} from "react-router-dom";


const PostsListPage = ({catIds, postShowSet}) => {
    const [posts, setPosts] = useState([]);
    const [mainCatId/*, setMainCatId*/] = useState(catIds[0]);
    const [subCatId/*, setSubCatId*/] = useState(catIds[1]);
    const navigator = useNavigate();

    /*    useEffect(() => {
            if (catIds !== null && catIds.length === 2 && catIds[0]!==0 && catIds[1]!==0) {
                setMainCatId(catIds[0]);
                setSubCatId(catIds[1]);
                localStorage.setItem("categoryIds", catIds);
            } else {
                let storageCatIds = localStorage.getItem("categoryIds");
                console.log(storageCatIds)
                if (storageCatIds !== null && storageCatIds.length === 2) {
                    setMainCatId(storageCatIds[0]);
                    setSubCatId(storageCatIds[1]);
                } else {
                    navigator("/blog");
                }
            }
        }, []);*/


    const [loggedUser, setLoggedUser] = useState({token: "", message: "", state: "", userNameFamily: "", userMode: ""});
    const currentLoggedUser = JSON.parse(sessionStorage.getItem("user"));
    if (currentLoggedUser != null && currentLoggedUser.state === "success"
        && currentLoggedUser.token !== loggedUser.token) {
        setLoggedUser({
            state: currentLoggedUser.state,
            token: currentLoggedUser.token,
            message: currentLoggedUser.message,
            userMode: currentLoggedUser.user_mode,
            userNameFamily: currentLoggedUser.user_name_family
        });
    }


    useEffect(() => {
        const fetchPosts = async () => {
            const postsRes = await getPosts("get_all_posts_in_cat");
            setPosts(postsRes.data);
            // console.log(postsRes);
        }
        fetchPosts();
    }, []);
    const formData = new FormData();

    const getPosts = async (appendUrl) => {
        formData.append('main_category_id', mainCatId);
        formData.append('sub_category_id', subCatId);
        let url = Constants.BaseUrl.concat(appendUrl);
        const postsRes = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                /*   'Content-Type': 'application/json',
                   'Accept': 'application/json',*/
            },
            body: formData
        });
        return await postsRes.json();
    }

    return (

        <>

            <div className="container">
                {(posts != null) && <div>
                    <div className="row text-center">
                        {posts.map((postItem, index) => (
                            <div key={postItem.id} className="col-md-6 g-3 ">
                                <div className="card bg-light border-success h-100">
                                    <img className="card-img-top h-50" src={postItem.blog_index_image}
                                         alt=""/>
                                    <div className="card-body text-center justify-content-center">
                                        <h3 className="text-center text-dark fw-bolder mb-3">{postItem.blog_title}</h3>
                                        <p className="text-md-end mt-3">{postItem.blog_summery}</p>
                                    </div>
                                    <div className="card-footer text-start">
                                        <button/* to="/read_single_post"  TODO :should be edited*/
                                            className="btn btn-lg btn-success text-white fw-bolder"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                postShowSet(postItem);
                                                // postIdShowSet(postItem.id);
                                                navigator("/read_single_post");
                                            }}>بیشتر
                                            بخوانید!
                                        </button>
                                        {(loggedUser.userMode === "admin") &&
                                        <button  /* TODO :should be edited*/
                                            onClick={(e) => {
                                                e.preventDefault();
                                                postShowSet(postItem);
                                                navigator("/edit_post");
                                            }} className="btn btn-primary btn-lg text-light fw-bolder">ویرایش
                                            پست</button>
                                        }

                                    </div>
                                </div>
                            </div>
                        ))
                        }
                    </div>

                    <div className="d-flex text-center justify-content-center align-items-center my-3">
                        {/*<p>links here</p>*/} {/*TODO: in ghesmat bayad link hayii baraye raftan b safahate baad bashad*/}
                    </div>
                </div>
                }
                {(posts == null || posts.length <= 0) &&
                <div className="text-center pt-5">

                    <h3 className="my-5 mx-auto text-center fw-bolder">هیچ پستی برای نمایش وجود ندارد.</h3>
                    <Link to="/" className="btn btn-primary btn-lg text-center text-light fw-bolder my-3 mx-auto">بازگشت
                        به صفحه
                        اصلی</Link>
                </div>
                }
            </div>

        </>
    );
}

export default PostsListPage;